import { forwardRef } from 'react';
import { Button } from '@robocorp/components';
import { IconDotsHorizontal } from '@robocorp/icons/iconic';
import { ExtractProps } from '~/types';

type ButtonProps = Partial<ExtractProps<typeof Button>>;

export const CellButton = forwardRef<HTMLButtonElement, ExtractProps<ButtonProps>>(
  ({ icon = IconDotsHorizontal, variant = 'ghost', ...buttonProps }, forwardedRef) => (
    <Button
      icon={icon}
      variant={variant}
      aria-label="Row Actions"
      {...buttonProps}
      ref={forwardedRef}
    />
  ),
);
